import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Header.module.css';

// Mock icons for simplicity. You can replace these with SVG or an icon library.
const SettingsIcon = () => <span>⚙️</span>;
const ProfileIcon = () => <span>👤</span>;

const Header = () => {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate('/dashboard');
  };

  return (
    <header className={styles.header}>
        <div
          className={styles.logo}
          onClick={handleLogoClick}
        >
          <img src="/images/BenX_Logo.webp" alt="BenX Logo" />
        </div>
        <div className={styles.actions}>
            <button className={styles.iconButton}><SettingsIcon /></button>
            <button className={styles.iconButton}><ProfileIcon /></button>
        </div>
    </header>
  );
};

export default Header;